import { defineMessages } from 'react-intl';

export default defineMessages({
  pendingDocumentsTabTitle: {
    id: 'lawyer_document_page.pending_validation_documents_tab_title',
  },
  validatedDocumentsTabTitle: {
    id: 'lawyer_document_page.validated_documents_tab_title',
  },
  rejectedDocumentsTabTitle: {
    id: 'lawyer_document_page.rejected_documents_tab_title',
  },

  claimNature: {
    id: 'lawyer.documents_table.table_header.claim_nature',
  },
  policyNumber: {
    id: 'lawyer.documents_table.table_header.policy_number',
  },
  registrationNumber: {
    id: 'lawyer.documents_table.table_header.registration_number',
  },
  vehiculeBrand: {
    id: 'lawyer.documents_table.table_header.vehicule_brand',
  },
  lossDate: {
    id: 'lawyer.documents_table.table_header.loss_date',
  },
  pendingDocumentsTitle: {
    id: 'lawyer.documents_pending_validation_table.title',
  },
  requiredDocumentsTitle: {
    id: 'lawyer.documents_table.table.required_documents.title',
  },
  linesPerPage: {
    id: 'lawyer.documents_table.table.lines_per_page',
  },
  validatedDocumentsTitle: {
    id: 'lawyer.validated_documents_table.title',
  },
  rejectedDocumentsTitle: {
    id: 'lawyer.rejected_documents_table.title',
  },
  claimNumber: {
    id: 'lawyer.documents_table.table_header.claim_number',
  },
});
